import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { rememberPostAuthRedirect } from "../../lib/postAuthRedirect";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin h-8 w-8 border-4 border-brand-600 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Back here after signing in: by password (the login page reads `from`), with Google, or after
    // signing up (both read the note), with the query kept (?race=…&car=…&tab=…).
    rememberPostAuthRedirect(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && user?.role !== "ADMIN") {
    return (
      <div className="container-page py-20 text-center">
        <h1 className="text-4xl font-bold text-gray-300 dark:text-gray-700 mb-4">403</h1>
        <p className="text-gray-600 dark:text-gray-400">
          You don't have permission to access this page.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
